import { render } from "./UserPermissions.vue?vue&type=template&id=ed4d7932&scoped=true"
import script from "./UserPermissions.vue?vue&type=script&lang=js"
export * from "./UserPermissions.vue?vue&type=script&lang=js"

import "./UserPermissions.vue?vue&type=style&index=0&id=ed4d7932&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed4d7932"]])

export default __exports__